import { AppRoutes, resolveRoute } from "config/router";
import {NavigateOptions, useNavigate} from "react-router-dom";

export default function useAppNavigation() {
    const navigate = useNavigate();

    const appNavigate = (route: AppRoutes | string | number, params?: Record<string, string | number>, navigateOptions?: NavigateOptions) => {
        let path = route;
        if(typeof route !== 'number') path = resolveRoute(route, params);
        navigate(path as any, navigateOptions);
    }

    return appNavigate;
}
